import React, {FC, useCallback, useState} from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { IDisplayUser, postContactUsReceiptEmail, postContactUsSalesAdminEmail } from '../../../common/async/AsyncCalls';
import { IUserState } from '../../../common/state/profile/user';
import ContactUsForm, { ContactUsFormData } from '../../../components/forms/contact/ContactUs.form';
import NavbarUser from '../../../components/navbar/Navbar.user';
// custom

const UserContactView : FC = () => {
    // states
    const userProfile : IDisplayUser = useSelector(({user} : {
        user: IUserState
    }) => user.profile);
    const token: string = useSelector(({user} : {user: IUserState}) => user.token);
    const [isFormDisabled, toggleFormDisabled] = useState(false);

    //lifecycle
    const triggerEmails = useCallback(async (data: ContactUsFormData) => {
        if (!token || token === '') return;
        try {
            toggleFormDisabled(true);
            await postContactUsSalesAdminEmail(token, data);
            await postContactUsReceiptEmail(token);
            toast('Email sent!');
        } catch(err) {
            console.log('Error sending emails: ', err);
            toast('Error sending email!');
        } finally {
            toggleFormDisabled(false);
        }
    },[token]);

    // evt handlers
    async function handleFormSubmission(formData: ContactUsFormData) {
        triggerEmails(formData);
    }
    
    return <React.Fragment>
        <NavbarUser/>
        <div
            className="h-screen overflow-y-scroll bg-gray-200 dark:bg-gray-800 flex flex-col 
                justify-start items-center text-gray-700 dark:text-gray-300 dartext-base">            
            <ContactUsForm
                isLoading={isFormDisabled}
                defaultFormData={{
                    name: userProfile.name ?? '',
                    contact_number: '',
                    subject: '',    
                    message: '',    
                }} 
                onSubmit={handleFormSubmission}/>
        </div>
    </React.Fragment>
};

export default UserContactView;